import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App as AntApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'antd/dist/reset.css';
import './styles.css';
import { App } from './App';
import { consoleTheme } from './console';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider locale={zhCN} theme={consoleTheme}>
      <AntApp message={{ top: 68, maxCount: 3 }}><App /></AntApp>
    </ConfigProvider>
  </StrictMode>,
);
